import { render, staticRenderFns } from "./PageFullWidth.vue?vue&type=template&id=5dae4038"
import script from "./PageFullWidth.vue?vue&type=script&lang=js"
export * from "./PageFullWidth.vue?vue&type=script&lang=js"
import style0 from "./PageFullWidth.vue?vue&type=style&index=0&id=5dae4038&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports